import Menu from './menu'

export default Menu;



// WEBPACK FOOTER //
// ./src/structure/menu/index.js